// import Vue from 'vue'
import axios from 'axios'
/* 按需引入mint UI */
import { Toast} from 'vant';
import qs from 'qs'
export default {
  axios: null,
  $router: null,
  env () {
    if (process.env.NODE_ENV === 'development' || window.location.href.includes('192.168')) return 'development'
    if (window.location.href.includes('test-')) return 'test'
    return 'production'
  },
  baseUrl () {
    if (this.env() === 'development') return 'http://192.168.220.32:8084/api/'
    if (this.env() === 'test') return 'http://test-isp.gzjunbo.net/'
    return 'http://isp.gzjunbo.net/'
  },
  couponBaseUrl () {
    if (this.env() === 'development') return 'http://test-isp.gzjunbo.net/'
    // if (this.env() === 'test') return 'http://test-isp.gzjunbo.net/'
    return '/'
  },
  cardUrl () {
    if (this.env() === 'development') return 'http://test-card.liulianglf.cn/'
    if (this.env() === 'test') return 'http://test-card.liulianglf.cn/'
    return 'https://card-api.liulianglf.cn/'
  },
  timeout () {
    if (this.env() === 'development') return 600000
    return 6000
  },
  install (Vue, options) {
    if (Vue) {
      Vue.prototype.$api = this
    }
    this.axios = axios.create({
      baseURL: this.baseUrl(),
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      timeout: this.timeout()
    })
  },
  ServiceProxy () {
    if (this.env() === 'development') return 'http://192.168.218.8:8085/ServiceProxy.aspx'
    if (this.env() === 'test') return 'http://test-transfer.liulianglf.com/ServiceProxy.aspx'
    return 'http://transfer.liulianglf.com/ServiceProxy.aspx'
  },
  _vkcServer: null,
  getVkcServer () {
    if (!this._vkcServer) {
      var servicePara = {
        key: 'jbfly',
        containKey: true,
        defExt: '',
        url: this.ServiceProxy()
      }
      if (window['jc']) {
        this._vkcServer = window['jc'].createService(servicePara)
        // console.log('init jc server', this._vkcServer)
      }
    }
    return this._vkcServer
  },
  /**
   * vkc ajax post  统一处理失败情况，弹出后台给的失败msg
   * @param url  路径（不包括IP）
   * @param data  传的数据
   * @param getAllData  成功后是否返回所有数据
   * return 无getAllData 返回后台数据中data中的数据
   *        有getAllData 返回所有后台数据
   */
  vkcPost (url, data, getAllData) {
    return new Promise((resolve, reject) => {
      this.getVkcServer().ajax(this.baseUrl() + url, data).done(res => {
        console.log(res)
        if (res.Code === 100) {
          if (~~res.Result.code === 0) {
            if (!getAllData) {
              resolve(res.Result)
            }
            resolve(res.Result)
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              code: res.Code,
              message: res.Msg
            })
            Toast(res.Result.msg)
          }
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            code: res.Code,
            message: res.Msg
          })
          Toast(res.Result)
        }
      })
    })
  },
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  post (url, data) {
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay:true
    });
    return new Promise((resolve, reject) => {
      this.axios.post(this.couponBaseUrl() + url, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          Toast.clear();
          resolve(response.data)
        }, err => {
          Toast('加载失败，请稍后重试...')
          resolve('error')
          reject(err)
        })
    })
  },
  setCookie (key, value, time) {
    var cur = new Date()
    cur.setTime(cur.getTime() + time * 24 * 3600 * 1000)
    document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + (time ? cur.toGMTString() : '')
  },
  getCookie (key) {
    var data = document.cookie
    var startIndex = data.indexOf(key + '=')
    if (startIndex > -1) {
      startIndex = startIndex + key.length + 1
      var endIndex = data.indexOf(';', startIndex)
      endIndex = endIndex < 0 ? data.length : endIndex
      return decodeURIComponent(data.substring(startIndex, endIndex))
    } else {
      return ''
    }
  },
  delCookie (key) {
    var data = this.getCookie(key)
    if (data !== false) this.setCookie(key, data, -1)
  },
  /**
   * 获取验证码
   */
  getcode (formData) {
    let param = {
      ...formData
    }
    return this.vkcPost('sh/youku/getcode', param)
  },
  /**
   * 登录
   */
  login (formData) {
    let param = {
      ...formData
    }
    return this.vkcPost('sh/youku/login', param)
  },
  /**
   * 订购
   */
  order (formData) {
    let param = {
      ...formData
    }
    return this.vkcPost('sh/youku/order', param)
  },
  /**
   * 充值
   */
  sellcoupon (formData) {
    let _this = this
    let param = {
      phoneNo: formData.chargeNo,
      productId: formData.productId,
      payType: '2',
      userCode: _this.getCookie('usercode'),
      orgId: '2019122610220248600013',
      returnUrl: encodeURI('http://sell.liulianglf.com/index.html'),
      orderId: formData.orderId
    }
    console.log(param)
    return _this.vkcPost('phonecard/sellcoupon', param)
  },
  getToken (formData) {
    let _this = this
    let param = {
      phoneNo: formData.chargeNo,
      userCode: _this.getCookie('usercode')
    }
    return _this.post('phonecard/token', param)
  },
  addCookie: function (key, value) {
    var d = new Date()
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000))
    var expires = 'expires=' + d.toUTCString()
    // var cvalue = window.JSON.stringify(value)
    var cvalue = value
    // console.info(key + "=" + cvalue + "; " + expires);
    document.cookie = key + '=' + cvalue + '; ' + expires
    // console.info(document.cookie);
  },
  url: function (key) {
    var getUrlVars = function () {
      // eslint-disable-next-line one-var
      var vars = [],
        hash
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=')
        if (hash.length > 1) {
          vars.push(hash[0])
          // eslint-disable-next-line no-useless-escape
          vars[hash[0]] = hash[1].replace(/[#|\?].+/, '')
        }
      }
      return vars
    }
    var getUrlVar = function (name) {
      return getUrlVars()[name]
    }
    return getUrlVar(key)
  },
  _usercode: '',
  usercode: function (usercode) {
    if (usercode) {
      this.addCookie('usercode', usercode)
      this._usercode = usercode
    }
    return this._usercode
  },
  /**
   * 开始支付
   * @param data 当为支付宝时-支付宝支付字符串 当是微信时
   * @returns {Promise}
   */
  go_pay: function (data) {
    var self = this
    return new Promise(function (resolve, reject) {
      if (window['WeixinJSBridge']) {
        // alert(window.JSON.stringify(data));
        if (typeof data === 'string') {
          data = window.JSON.parse(data)
        }
        if (!data['AppId']) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            code: 1,
            data: '支付失败！缺少支付参数！',
            msg: 'fail'
          })
          return
        }
        self.setPaying(true)
        // 微信处理
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
          'appId': data.AppId, // 公众号名称，由商户传入
          'timeStamp': data.Timestamp, // 时间戳，自1970年以来的秒数
          'nonceStr': data.Nonce, // 随机串
          'package': data.Package,
          'signType': data.SignType, // 微信签名方式：
          'paySign': data.Sign // 微信签名
        },
        function (res) {
          self.setPaying(false)
          if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              code: 2,
              data: '您取消了支付',
              msg: 'fail'
            })
          } else if (res.err_msg === 'get_brand_wcpay_request:ok') {
            resolve({
              code: 0,
              data: '支付成功！',
              msg: 'success'
            })
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              code: 1,
              data: '支付失败！',
              msg: 'fail'
            })
          }
        }
        )
      } else {
        var obj = JSON.parse(data)
        window.location.href = obj.MWebUrl + '&redirect_url=' + encodeURIComponent(window.location.href)
      }
      // reject({code: 3, data: '支付端异常', msg: 'fail'});
    })
  },
  setPaying: function (status) {
    return this.addCookie('is_paying', status)
  },
  getPaying: function () {
    return this.getCookie('is_paying')
  },
  toPost(url, params, all){
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay:true
    });
    return new Promise((resolve, reject) => {
      this.axios({
        method: 'post',
        url: all? url : this.couponBaseUrl() + url,
        data: params
      })
      .then(res=>{
        Toast.clear();
        resolve(res.data)
      })
      .catch(err=>{
        Toast('加载失败，请稍后重试...')
        console.log(err)
      })
    })
  },
  toGet(url, params){
    return new Promise((resolve, reject) => {
      this.axios({
        method: 'get',
        url: url,
        data: params
      })
      .then(res=>{
        resolve(res.data)
      })
      .catch(err=>{
        console.log(err)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/index.js